import { useEffect, useState } from 'react';
import qs from 'query-string';
import { globalHistory, useLocation, useNavigate } from '@reach/router';
import { createHookContext } from '@clover-util/react-context';

export type PersistentQueryParamState = {
  order_type?: string,
  table_id?: string
  employee_id?: string;
};

const getStateFromSearch = (search: string) : PersistentQueryParamState => {
  const params = qs.parse(search);

  return {
    order_type: params['order_type'] ? params['order_type'].toString() : undefined,
    table_id: params['table_id'] ? params['table_id'].toString() : undefined,
    employee_id: params['employee_id'] ? params['employee_id'].toString() : undefined,
  };
};

export const [usePersistentQuery, PersistentQueryParamProvider] = createHookContext('PersistentQueryParam', () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState(getStateFromSearch(location.search));

  useEffect(() => {
    return globalHistory.listen((history) => {
      if (qs.stringify(state).length !== 0 && history.location.search !== `?${qs.stringify(state)}`) {
        navigate(`${history.location.pathname}?${qs.stringify(state)}`, { replace: true, state: history.location.state });

        return;
      }

      setState(getStateFromSearch(history.location.search));
    });
  }, [state, navigate]);

  return state;
});
